module.exports = __webpack_public_path__ + "static/media/wolf-fox@2x.59ae3a7f.jpg";